import ReportComponent from '../../utils/ReportComponent/ReportComponent';
import typeOf from '../../helpers/typeOf';
import config from '../../config';

const reportFormatter = ReportComponent.formatter;
const reportUtils = ReportComponent.utils;
const reportGetParams = ReportComponent.getParams;
const numericFormats = new Set(['number', 'percent', 'currency']);

const getCellClass = (key, parameters = {}) => {
    const params = key === 'GroupBy'
        ? {
            metricKey: key,
            key: parameters.group_by
        }
        : key;
    const format = reportGetParams(params)?.format;
    return numericFormats.has(format) ? 'number' : 'text';
};

export const getMetric = (key, value, parameters, isTotals = false) => {
    let params = key;
    if (key === 'GroupBy') {
        params = {
            metricKey: key,
            key: parameters.group_by,
            isTotals
        };
    }

    return reportFormatter.format(value, params, parameters);
};

export const getTr = (data, parameters, isTotals) => {
    const trClass = isTotals ? ' class="totals-row"' : '';
    let str = `<tr${trClass}>`;

    const keys = reportUtils.getKeysMetric();
    keys.map((key) => {
        let value = getMetric(key, data[key], parameters, isTotals);

        if (typeOf.isArray(value)) {
            value = `${value[0]}${config.XBT}`;
        }

        str += `<td class="${getCellClass(key, parameters)}">${value}</td>`;
    });

    str += '</tr>';

    return str;
};
